import React, { memo } from 'react'
import { Box, InputLabel, styled, Typography } from '@mui/material'
import { COLORS } from '../../../constants/colors'
import styles from './TextareaField.module.scss'
import Error from '../Error'
import { ErrorMessage, useFormikContext } from 'formik'

const StyledInputLabel = styled(InputLabel)`
  &.MuiInputLabel-root {
    margin-bottom: 8px;
    font-size: 16px;
    color: ${COLORS.darkestGray};
    font-weight: 400;
    line-height: 24px;
    text-align: start;
  }
`

const StyledTypography = styled(Typography)`
  &.MuiTypography-root {
    padding-top: 4px;
    font-size: 12px;
    color: ${COLORS.lighterRed};
    font-weight: 600;
  }
`

const StyledBox = styled(Box)`
  &.MuiBox-root {
    height: 32px;
  }
`

interface TextareaFieldProps {
  name: string
  value: string
  errors?: { [key: string]: string }
  label?: string
  placeholder?: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

const TextareaField: React.FC<TextareaFieldProps> = ({ value, onChange, errors, ...props }) => {
  const formik = useFormikContext()

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.currentTarget.value.replace(/^\s+/, '')
    formik.setFieldValue(props.name, newValue)
    if (onChange) {
      onChange(e)
    }
  }
  return (
    <div style={{ width: '100%' }}>
      {props.label && <StyledInputLabel>{props.label}</StyledInputLabel>}
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={props.placeholder}
        className={styles.container}
        rows={4}
      ></textarea>
      <Error>
        <ErrorMessage name={props.name}>
          {(msg) => <span className={styles.errorMsg}>{msg}</span>}
        </ErrorMessage>
      </Error>
    </div>
  )
}

export default memo(TextareaField)
